import type { TVacationBalance, TVacationRequest, TVacationStatus } from "@/types"
import { api } from "./api"
import { generateAPIResource, generateSetupActivity } from "./utils"

export const vacationAPI = {
  ...generateSetupActivity("/vacation"),
  test: () => api.post("/vacation/test").then((res) => res.data),
}

export const vacationBalancesAPI = {
  fetch: (userIds?: string[]) =>
    api
      .get<TVacationBalance[]>("/vacation/balances", {
        params: userIds ? { where: { user_id: { $in: userIds } } } : {},
      })
      .then((res) => res.data),
  correct: (user_id: string, available: number) =>
    api.post<TVacationBalance>("/vacation/balances", { user_id, available }).then((res) => res.data),
}

export async function importAPIVacationBalancesCSV(file: File) {
  const formData = new FormData()
  formData.append("csv", file)
  const { data } = await api.post<{ processed: number; skipped: number }>("/vacation/export/balances.csv", formData)
  return data
}

export async function importAPIVacationRequestsCSV(file: File) {
  const formData = new FormData()
  formData.append("csv", file)
  const { data } = await api.post<{ processed: number; skipped: number }>("/vacation/export/requests.csv", formData)
  return data
}

export const vacationRequestAPI = {
  ...generateAPIResource<TVacationRequest>("/vacation/requests", {
    create: true,
    update: false,
    remove: false,
  }),
  review: (id: string, payload: { status: TVacationStatus; rejection_reason?: string }) =>
    api.post<TVacationRequest>(`/vacation/requests/${id}/review`, payload).then((res) => res.data),
}
